<template>
    <div v-if="storeLocation" class="full-width">
        <ion-label v-if="showTodayHours && storeLocation.boldDisplayTime" v-html="storeLocation.boldDisplayTime" />

        <ion-accordion-group v-else style="width: 100%">
            <ion-accordion>
                <ion-item slot="header" class="time-header">
                    <ion-label class="pl-16">
                        <span v-html="storeLocation.boldDisplayTime" />
                    </ion-label>
                </ion-item>

                <ion-row slot="content" v-if="storeLocation.weeklyHours" class="ion-padding-bottom color-dark">
                    <ion-col size="12" class="py-0" v-for="(day, i) in storeLocation.weeklyHours.slice(0, 7)" :key="i">
                        <time itemprop="openingHours" :content="day.schema">
                            <ion-row class="ion-no-padding small">
                                <ion-col class="ion-text-end ion-margin-end py-4"> {{ day.day }} </ion-col>
                                <ion-col size="7" class="py-4"> {{ day.times }} </ion-col>
                            </ion-row>
                        </time>
                    </ion-col>
                </ion-row>
            </ion-accordion>
        </ion-accordion-group>
    </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IonRow, IonCol, IonAccordionGroup, IonAccordion, IonItem, IonLabel } from '@ionic/vue';
import { StoreLocation } from '@/models/locationModels';
export default defineComponent({
    props: {
        storeLocation: {
            type: Object as PropType<StoreLocation>,
            required: true,
        },
        showWeeklyHours: Boolean,
        showTodayHours: Boolean,
        boldTime: Boolean,
    },
    components: { IonRow, IonCol, IonAccordionGroup, IonAccordion, IonItem, IonLabel },
});
</script>

<style scoped>
.time-header {
    margin-left: -16px;
}
</style>
